module.exports=function(scope){ return `// Signal to the FaceTec SDK that time based session images should be captured
[[Zoom sdk].enableTimeBasedSessionImages = true;

// Capture a User Session
UIViewController *sessionVC = [Zoom.sdk createSessionVCWithDelegate:self];
[self presentViewController:sessionVC animated:true completion:nil];

// Sample code to handle the session result
- (void) onZoomSessionResultWithResult:(ZoomSessionResult *)result {
    NSLog(@"Session result: %@", [@(result.status) stringValue]);

    // Session failed
    if ([result status] != ZoomSessionStatusUserProcessedSuccessfully) {
        // Handle results here
        return;
    }
    // retrieve the FaceTec SDK face biometric results
    ZoomFaceBiometricMetrics *faceMetrics = [result faceMetrics];

    if (faceMetrics != nil) {
        // Get the time based session image(s) if available
        NSArray *timeBasedSessionImages = (id) faceMetrics.timeBasedSessionImages;
        // Check the time based session images count
        NSLog(@"Time Based Session image count result: %@", [@(timeBasedSessionImages.count) stringValue]);
    }
    // Send the data to your chosen API for processing
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/ios/38-time-based-images.m.tpl